export default __webpack_public_path__ + "references-section.png";